import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Libellés FR de `mat-paginator`.
 *
 * Sans ça Material rend « Items per page », « Next page » et « 1 – 25 of 120 » :
 * l'app est francophone (règle §8), le défaut anglais serait une régression par
 * rapport à la pagination maison qu'il remplace.
 *
 * `MatPaginatorIntl` est une classe, pas un token de valeur : on l'étend au lieu
 * de fournir un objet littéral, pour hériter du `changes: Subject` que les
 * paginateurs écoutent.
 */
export class PaginatorIntlFr extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Par page';
  override nextPageLabel = 'Page suivante';
  override previousPageLabel = 'Page précédente';
  override firstPageLabel = 'Première page';
  override lastPageLabel = 'Dernière page';

  /** « 1–25 sur 120 » — même formulation que l'ancien `rangeLabel()`. */
  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0) {
      return '0 résultat';
    }
    const from = page * pageSize + 1;
    const to = Math.min((page + 1) * pageSize, length);
    return `${from}–${to} sur ${length}`;
  };
}
